import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsDvcsBitbucketRoute: InvariantJiraRoute = {
	name: 'global-settings-products-dvcs-bitbucket',
	path: '/secure/BitbucketPostInstallApprovalAction.jspa',
};
